function displayAnimationOnViewport() {
    const contents = document.querySelectorAll('.product-reviews__rating-summary');

    if (contents) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const target = entry.target;
                if ( entry.isIntersecting ) {
                    target.classList.toggle('__on_viewport', entry.isIntersecting);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: [0.5, 1]
        });
        contents.forEach((content) => observer.observe(content));
    }
}

displayAnimationOnViewport();
